<template>
  <div>
    <b-container>
      <small><label>Επιλογή Εκδότη</label></small>
      <b-row class="breakPoint">
        <b-col sm="10">
          <b-form-select v-model="selected" :options="options">
            <template slot="first">
              <option :value="null" disabled>-- Παρακαλώ επιλέξτε εκδότη --</option>
            </template>
          </b-form-select>
        </b-col>
        <b-button
                  variant="outline-info"
                  @click="searchPublisherBooks">Αναζήτηση
        </b-button>
      </b-row>
    </b-container>

    <br/>
    <b-container fluid v-show="searchEnable">
      <publisher-list-component></publisher-list-component>
    </b-container>
  </div>
</template>

<script>

  import requests from '../../js/DistributionRequestService';
  import Utils from '../../js/AppUtilities';
  import {GlobalEudoxusBus} from '../../js/DistributionRequestService';
  import PublisherListComponent from './PublisherListComponent.vue'

  export default {
    name: "publisher-form-component",
    data() {
      return {
        selected: null,
        publisherArray: [],
        publisherDto: '',
        options: [],
        tableMap: [],
        searchEnable: false
      }
    },
    components: {
      'publisherListComponent': PublisherListComponent
    },
    methods: {
      searchPublisherBooks() {
        this.selected != null ? requests.getBookAvailabilitiesForPublisher(this.selected, this.fillUpDataTable) : alert("Παρακαλώ επιλέξτε Εκδότη");
      },
      fillUpDataTable(resultArray) {
        this.tableMap = Utils.publisherBooksMapResolver(resultArray);
        this.publisherDto = Utils.getPublisherDtoById(this.selected, this.publisherArray);
        GlobalEudoxusBus.$emit('publisherBooksTableSetup', {'tableMap': this.tableMap, 'publisherDto': this.publisherDto});
        this.searchEnable = true;
      },
      selectOptions(result) {
        this.publisherArray = result;
        this.options = Utils.getPublisherOptions(result);
      },
      setUpComponent() {
        this.searchEnable = false;
        requests.getPublishers(this.selectOptions);
      }
    },
    created() {
      GlobalEudoxusBus.$on('publishSetupEvent', publishSetupEvent => {
        if (publishSetupEvent) {
          this.setUpComponent();
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PublisherComponents/PublisherFormComponent.vue